import type { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";

/**
 * The CSS selector a mod is positioned against, when it has one.
 *
 * Most mods are selector-positioned, but an onsite upsell anchored to an
 * Intelligems Content theme block is not: the merchant owns its
 * position in the theme editor, so there is no selector to highlight, look a
 * live node up by, or report. Callers that need one must handle its absence
 * rather than highlighting `undefined`.
 */
export function modSelector(mod: EmbeddedMod): string | undefined {
  return "selector" in mod && mod.selector ? mod.selector : undefined;
}
